import { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import * as gtag from '@lib/utilities/analytics'

/**
 * Back-to-top. The v4 version styled it `bg-orange hover:bg-blue` — classes
 * from the OLD theme that no longer exist in the Tailwind 4 token set, so the
 * button rendered as a white ghost with no contrast on the white page ground.
 * Now violet-700 with a white ring: the ring is what keeps it visible when it
 * floats over the violet footer and CTA bands, where a bare violet disc would
 * vanish.
 */
export default function BackToTop() {
  const { t } = useTranslation('main')
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const onScroll = () => setShowButton(window.scrollY > 300)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollToTop = () => {
    // NOT 'page_view' (the v4 name): that event is GA4's page-view metric,
    // owned by @next/third-parties — firing it here double-counted views
    gtag.event('back_to_top_click', { event_category: 'engagement' })
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  if (!showButton) return null
  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label={t('common.backToTop')}
      className="fixed bottom-20 right-3 z-20 hidden cursor-pointer rounded-full bg-violet-700 p-3.5 text-white shadow-[0_6px_20px_rgba(102,0,204,0.35)] ring-2 ring-white/80 transition-colors hover:bg-violet-800 md:block"
    >
      <svg width="1.4rem" height="1.4rem" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 19V5M5.5 11.5 12 5l6.5 6.5" />
      </svg>
    </button>
  )
}
